import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=2781cd72&"
import script from "./FooterComponent.vue?vue&type=script&lang=ts&"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports